export default class DtoNature {
    constructor(obj) {
        this.code = obj.code
        this.libelle = obj.libelle
        this.name = obj.libelle
    }
}